addPossibleTypes